import { JSONSchema4 } from 'json-schema';
/* tslint:disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export interface GetWorkflowPendingRequestsContract {
  total_pending: number;
  [k: string]: unknown;
}

export default <JSONSchema4>{
  type: 'object',
  properties: { total_pending: { type: 'number' } },
  required: ['total_pending'],
};
